export default __webpack_public_path__ + "static/media/discoball.1423a3b9.png";